import { render, staticRenderFns } from "./UsersMonth.vue?vue&type=template&id=2390c74c&"
import script from "./UsersMonth.vue?vue&type=script&lang=js&"
export * from "./UsersMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports